import Modal from '../Modal/Modal';
import { useMetadata } from '../../context/MetadataContext';
import { useTournamentLeaderboard } from '../../hooks/useTournamentLeaderboard';
import CountryFlag from '../../utils/CountryFlag';
import styles from './LeaderboardModal.module.css';

const LeaderboardModal = ({ isOpen, onClose, tournamentKey }) => {
  const { getText } = useMetadata();
  const { leaderboardData, isLoading } = useTournamentLeaderboard(isOpen, tournamentKey);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={getText('tournament_mode.leaderboard_title')}
      className={styles.leaderboardModal}
    >
      <div className={styles.content}>
        {isLoading ? (
          <div className={styles.loading}>
            {getText('common_text.loading')}
          </div>
        ) : leaderboardData.length === 0 ? (
          <div className={styles.noData}>
            {getText('tournament_mode.leaderboard_no_data')}
          </div>
        ) : (
          <div className={styles.leaderboardList}>
            <div className={styles.leaderboardHeader}>
              <span>{getText('common_text.rank')}</span>
              <span>{getText('common_text.nickname')}</span>
              <span>{getText('tournament_mode.solved_label')}</span>
            </div>
            {leaderboardData.map((leader) => (
              <div key={`${leader.rank}-${leader.nickname}`} className={styles.leaderboardRow}>
                <span className={styles.rank}>{leader.rank}</span>
                <span className={styles.nickname}>
                  {leader.nickname}
                  {leader.country_code && (
                    <CountryFlag 
                      countryCode={leader.country_code} 
                      style={{ marginLeft: '8px', width: '1em', height: '1em' }}
                    />
                  )}
                </span>
                <span className={styles.puzzlesSolved}>{leader.puzzles_solved}</span>
              </div>
            ))}
          </div>
        )}
        
    
      </div>
    </Modal>
  );
};

export default LeaderboardModal;